export const SIZE = 4;
export const MAX_SCORE = 4096;